import template from './webtip-main-view.html'
import './webtip-main-view.controller'
import './analog-chart'
import './digital-chart'

const webtipMainView = {
  bindings: {},
  template,
  controller: 'WebtipMainViewController',
};
angular
  .module('webtip.module')
  .component('webtipMainView', webtipMainView)
  .config(function ($stateProvider) {
    $stateProvider
      .state('webtip', {
        // Changed route path from /webtip to /otdr (state name kept as 'webtip' for backward compatibility)
        url: '/otdr',
        component: 'webtipMainView',
        resolve: {
          auth:  (userService, $state, eventService) => {
            userService
              .resolve(['ACCESS_NOTHING'])
              .then(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('access-nothing');
              })
              .catch(() => {
              });

            return userService
              .resolve(['VIEW_RMM'])
              .then(() => {
              })
              .catch(() => {
                eventService.trigger('userservice:unauthorized');
                $state.go('frontpage');
              });
          },
        },
      });
  });